import  { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import "./ChatCard.css";
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext";
import XmarkIcon from "../../atoms/iconsComponent/XmarkIcon";
import pinkIcon from '../../../assets/logo192.png'
import { MessageComponent } from "../../organism";
import { LoginType } from "components/types/Context";
import { addZero, chatDepartmentFormat, fromGetMonthToMonthName } from "shared/utils/formatFunction";

type RecipientChat = {
  name: string;
  logoUrl: string;
}
interface chatPropType {
  recipient?: RecipientChat;
}

export const ChatCard = ({ recipient }: chatPropType) => {
  const { reqMessagesList, chatIsOpen, setChatIsOpen, matchSelected, startupAcceptedMatch, messagesList, setMatchSelected, getMessagesList, loginType } = useContext(AppGeneralContext);
  const chatEndRef = useRef<any>(null)
  const [logoStatup] = useState<string>(matchSelected?.startup.logoUrl ? matchSelected?.startup.logoUrl : pinkIcon)

  const scrollToBottom = useCallback (() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" })
  },[chatEndRef,matchSelected])

  useEffect(()=>{
    if(chatEndRef && matchSelected?.id){
    if(chatEndRef.current?.id === `M${matchSelected.id}`){
      getMessagesList()
      scrollToBottom()
    }else{
      getMessagesList()
    }
  }
  },[matchSelected?.id, chatEndRef, chatEndRef.current?.id])

  useEffect(() => {

    getMessagesList()
    scrollToBottom()
 
  }, [reqMessagesList,matchSelected?.id, chatEndRef.current?.id])

 

  const clickHandler = () => {
    setChatIsOpen(false);
    setMatchSelected(undefined)
  };

  const showChat = useMemo(() => {
    if (chatIsOpen) {
      return (
        <div className="chat ">
          <div className="chat-cont h-100 w-100  d-flex flex-column">
            <div className="chat-row ms-3 me-3 chat-title d-flex  ">
              <div className="d-flex w-100 h-100 align-items-center ">
                <img className="h-75" src={loginType === LoginType.corporate ? logoStatup : pinkIcon} alt="logo startup" />
                <div className="m-0 p-0 ms-2 justify-content-center d-flex flex-column">
                <h5 className="m-0 p-0  fv-900">{loginType === LoginType.corporate ? matchSelected?.startup.name : matchSelected?.company.name}</h5>
                <span className="department-font">{loginType === LoginType.startup ? 
                chatDepartmentFormat(matchSelected?.companyDepartment?.label) : 
                chatDepartmentFormat(matchSelected?.startup.sector?.label)}
                </span>
                </div>
              </div>
              <div
                onClick={() => clickHandler()}
                className="d-flex w-25 justify-content-end  align-items-center"
              >
                <XmarkIcon className="close " />
              </div>
            </div>
            <div className="chat-row chat-box   ">
              <div className="chat-content  w-100 h-100 pt-3 ps-4 pe-4 ">
                 {messagesList.map((x) => {
              
                    const messageDate = new Date(x.dateAction)
                    const dayMessage = addZero(messageDate.getDate())
                    const monthMessage = fromGetMonthToMonthName(messageDate.getMonth())
                    const yearMessage = messageDate.getFullYear()
                    const dateMessage = dayMessage + " " + monthMessage + " " + yearMessage
          

                  return <div key={x.id}>
                    {x.showDate &&
                      <div className="d-flex flex-row w-100 pt-2 pb-2 align-items-center">
                        <div className="date-message-line " />
                        <p className="date-message ps-3 pe-3 p-0 m-0"> {dateMessage} </p>
                        <div className="date-message-line " />
                      </div>
                    }
                    <MessageComponent
                      message={x}
                      startup={matchSelected?.startup}
                      corporate={matchSelected?.company}
                    />
                  </div>
                })
                }
                <div ref={chatEndRef} id={matchSelected?.id ? `M${matchSelected.id}` : "M"}  />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }, [chatIsOpen, messagesList]);

  return <>{showChat}</>;
};
